import { DatePipe } from "@angular/common";
import { Component, Input, OnInit, ViewChild } from "@angular/core";
import { UntypedFormControl, UntypedFormGroup, Validators } from "@angular/forms";
import { MatPaginator } from "@angular/material/paginator";
import { MatSort } from "@angular/material/sort";
import { MatTableDataSource } from "@angular/material/table";
import { ILicenseCash } from "app/models/core/lab/licenseCash";
import { AdminService } from "app/services/admin/admin.service";
import { SharedService } from "app/services/core/shared.service";
import { LabService } from "app/services/lab/lab.service";



@Component({
  selector: 'app-license-cash',
  templateUrl: './licenseCash.component.html'

})

export class LicenseCashComponent implements OnInit {
  @Input() stateNumber: string = '';

  list: ILicenseCash[] = [];
  saveValue: ILicenseCash;
  displayedColumns: string[] = ['licDate', 'licExpire', 'cashDate',
    'crNum', 'cert', 'amtPd', 'credit', 'licashId'
  ];

  dataSource = new MatTableDataSource<ILicenseCash>(this.list);

  selectedLab = '';
  listFilter = '';
  editMode = 'list';
  licExp = '';
  certNum = '';
  liCashId = 0;

  licenseFormGroup = new UntypedFormGroup({
    tranCd: new UntypedFormControl('',),
    bien: new UntypedFormControl('',),
    revCode: new UntypedFormControl('',),
    crNum: new UntypedFormControl('', [Validators.maxLength(20)]),
    cert: new UntypedFormControl({ value: '', disabled: true }, [Validators.maxLength(10)]),
    amtPd: new UntypedFormControl('', [Validators.maxLength(10)]),
    credit: new UntypedFormControl('', [Validators.maxLength(10)]),
    paidBy: new UntypedFormControl('',),
    licFee: new UntypedFormControl('',),
    auditnum: new UntypedFormControl('',),
    cashDate: new UntypedFormControl(new Date(),),
    labFee: new UntypedFormControl('',),
    dateCreated: new UntypedFormControl('',),
    createdBy: new UntypedFormControl('',),
    licExpire: new UntypedFormControl('',),
    comments: new UntypedFormControl('',),
    labId: new UntypedFormControl(0,),
    lastUpdated: new UntypedFormControl('',),
    updatedBy: new UntypedFormControl('',),
    licashId: new UntypedFormControl(0,),
    licDate: new UntypedFormControl(new Date(),)
  });

  @ViewChild('TablePaginator') paginator: MatPaginator;
  @ViewChild('TableSort') sort: MatSort;

  constructor(public labService: LabService,
    public sharedService: SharedService,
    public adminService: AdminService,
    private datePipe: DatePipe) { };

  ngOnInit() {
    if (this.labService.lab != null) {
      if (this.stateNumber != '') {
        this.loadLicenseCash();
      }
      this.editMode = 'list';
    }
  }

  loadLicenseCash() {
    this.labService.getLicenseCash(this.stateNumber).subscribe(
      res => {
        this.list = res;
      },
      error => console.log('error: ', error),
      () => {
        this.dataSource.data = this.list;
        this.dataSource.paginator = this.paginator;
        this.dataSource.sort = this.sort;
      }
    );

  }
  filterTable(evnt: Event) {
    this.listFilter = (evnt.target as HTMLInputElement).value;
    this.dataSource.filter = this.listFilter.trim().toLowerCase();
    sessionStorage.setItem('licenseCashFilter', this.listFilter);
  }

  clearFilter() {
    this.listFilter = "";
    this.dataSource.filter = this.listFilter;
    sessionStorage.setItem('licenseCashFilter', this.listFilter)
  }

  getPageSizeOptions(): number[] {
    if (this.dataSource.data.length > 20) {
      return [10, 20, this.dataSource.data.length];
    } else {
      return [10, 20];
    }
  }

  editLicenseCash(licenseCash: ILicenseCash) {
    this.editMode = 'edit';
    this.licenseFormGroup.controls['licExpire'].disable();
    this.licenseFormGroup.patchValue({
      tranCd: licenseCash.tranCd,
      bien: licenseCash.bien,
      revCode: licenseCash.revCode,
      crNum: licenseCash.crNum,
      cert: licenseCash.cert,
      amtPd: licenseCash.amtPd,
      credit: licenseCash.credit,
      paidBy: licenseCash.paidBy,
      licFee: licenseCash.licFee,
      auditnum: licenseCash.auditnum,
      cashDate: this.sharedService.getDate(licenseCash.cashDate),
      labFee: licenseCash.labFee != null ? licenseCash.labFee.toString() : '',
      dateCreated: licenseCash.dateCreated,
      createdBy: licenseCash.createdBy,
      licExpire: licenseCash.licExpire,
      comments: licenseCash.comments,
      labId: licenseCash.labId,
      lastUpdated: licenseCash.lastUpdated,
      updatedBy: licenseCash.updatedBy,
      licashId: licenseCash.licashId,
      licDate: this.sharedService.getDate(licenseCash.licDate)
    });
    this.liCashId = licenseCash.licashId;
    this.licExp = licenseCash.licExpire;
    this.certNum = licenseCash.cert;
    this.licenseFormGroup.markAsPristine();
  }

  print() {
    if (this.editMode == 'list') {
      if (this.labService.lab.certificateType == 'T') {
        this.adminService.printCurrentHstLicense(this.labService.lab.stateNumber).subscribe(
          res => {
            this.downloadFile("LabLicense_" + this.labService.lab.stateNumber, res);
          },
          error => console.log('error: ', error),
          () => {
          }
        );
      }
      else {
        this.adminService.printCurrentSoaLicense(this.labService.lab.stateNumber).subscribe(
          res => {
            this.downloadFile("LabLicense_" + this.labService.lab.stateNumber, res);
          },
          error => console.log('error: ', error),
          () => {
          }
        );
      }
    }
    else{
      this.adminService.printSingleLicense(this.liCashId,
          this.labService.lab.labType, this.labService.lab.stateNumber).subscribe(
        res => {
          this.downloadFile("LabLicense_" + this.labService.lab.stateNumber, res);
        },
        error => console.log('error: ', error),
        () => {
        }
      );

    }
  }

  downloadFile(fileName: string, blob: Blob) {
    let file = URL.createObjectURL(blob);
    var fileDownload = document.createElement('a');
    fileDownload.href = file;
    fileDownload.download = fileName;
    fileDownload.click();
  }

  addNewLicense() {
    this.editMode = 'add';
    this.licenseFormGroup.controls['licExpire'].enable();
    this.licenseFormGroup.patchValue({
      tranCd: '',
      bien: '',
      revCode: '',
      crNum: '',
      cert: this.labService.lab.stateNumber,
      amtPd: '',
      credit: '',
      paidBy: '',
      licFee: '',
      auditnum: '',
      cashDate: new Date(),
      labFee: '0',
      dateCreated: '',
      createdBy: '',
      licExpire: this.getDefaultDate(),
      comments: '',
      labId: parseInt(this.stateNumber),
      lastUpdated: '',
      updatedBy: '',
      licashId: 0,
      licDate: new Date()
    }
    );
  }

  deleteLicenseCash(id: string): void {
    if (!confirm('Delete this record? Continue?')) {
      return;
    }
    this.labService.deleteLicenseCash(id).subscribe(
      res => {
        this.loadLicenseCash();
      },
      error => console.log('error: ', error),
      () => {
      }
    );
  }

  saveLicenseCash() {
    let form = this.licenseFormGroup.getRawValue();

    let licenseCash: ILicenseCash = {
      tranCd: form.tranCd,
      bien: form.bien,
      revCode: form.revCode,
      crNum: form.crNum,
      cert: this.certNum,
      amtPd: form.amtPd,
      credit: form.credit,
      paidBy: form.paidBy,
      licFee: form.licFee,
      auditnum: form.auditnum,
      cashDate: form.cashDate == ''? 
          null : this.datePipe.transform(form.cashDate, 'MM/dd/yyyy') ,
      labFee: parseInt(form.labFee),
      dateCreated: form.dateCreated,
      createdBy: form.createdBy,
      licExpire: form.licExpire,
      comments: form.comments,
      labId: form.labId,
      lastUpdated: form.lastUpdated,
      updatedBy: form.updatedBy,
      licashId: form.licashId,
      licDate: form.licDate != ''? 
      this.datePipe.transform(form.licDate, 'MM/dd/yyyy') : null
    }
    this.saveValue = licenseCash;
    this.labService.saveLicenseCash(licenseCash).subscribe(
      res => {
        this.loadLicenseCash();
      },
      error => console.log('error: ', error),
      () => {
        this.editMode = 'list';
      }
    );

  }

  cancel() {
    if (this.checkDirty()) {
      if (!confirm('Unsaved changes. Continue?')) {
        return;
      }
    }
    this.editMode = 'list';
    this.loadLicenseCash();
  }

  checkDirty(): boolean {
    return this.licenseFormGroup.dirty;
  }

  getDefaultDate(): string {
    const currentYear = new Date().getFullYear();
    if (this.labService.certType === "T") {
      if (currentYear % 2 === 0) {
        this.licExp = "06/30/" + (currentYear + 2);
      } else {
        this.licExp = "06/30/" + (currentYear + 1);
      }
    } else {
      this.licExp = "12/31/" + currentYear;
    }
    return this.licExp;
  }
}